import React from 'react';
import { POC, PocType } from 'utils/entities';
import styled from '@emotion/styled';
import { AgentPhoto } from './styled';
import AgentPlaceholder from 'assets/svg/user-placeholder/agent-new.svg';
import UserPlaceholder from 'assets/svg/profile-new.svg';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { Link } from 'components/link';
import { Route } from 'config/routes';


const AgencyPhoto = styled.div<{ imageURL: string }>`
  width: 56px;
  min-width: 56px;
  height: 56px;
  overflow: hidden;
  background-size: contain;
  background-position: center center;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  ${({ imageURL }) => imageURL ? `background-image: url(${imageURL});` : ''}
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
`;

const AgentPhotoAdapted = styled(AgentPhoto)<{ big?: boolean }>`
  margin: 0;
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  ${props => props.big ? `
    width: 64px;
    height: 64px;
  ` : `
    width: 56px;
    height: 56px;
  `}
`;

const PhotoWrapper = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const NonClickableWrapper = styled.div<any>``;


interface HebrewContactImageProps {
  poc: POC;
  big?: boolean;
  showOnlyOffice?: boolean;
  nonClickableAgent?: boolean;
}

const HebrewContactImage: React.FC<HebrewContactImageProps> = ({ poc, big, showOnlyOffice, nonClickableAgent }) => {
  const constructImageURI = useImageUrlBuilder();
  let agentImageUrl;
  let agencyImageUrl;
  let officeId: string;
  let agentId: string;
  if (poc.type === PocType.Agent) {

    const { agentContact, officeContact } = poc;
    officeId = poc.officeId;
    agentId = poc.agentId;
    agentImageUrl = agentContact && constructImageURI(agentContact.imageUrl);
    agencyImageUrl = officeContact && constructImageURI(officeContact.imageUrl, {
      width: 64,
      height: 64,
      fit: 'contain',
      padding: 8,
    });
  }
  else if (poc.contactInfo) {
    agentImageUrl = constructImageURI(poc.contactInfo.imageUrl);
  }

  const PhotoAgentWrapper = nonClickableAgent ? NonClickableWrapper : Link;

  const agentLink = <PhotoAgentWrapper routeName={Route.AgentPage} routeParams={{ id: agentId, source: 'listing_page' }}><AgentPhotoAdapted imageURL={agentImageUrl} big={big} /></PhotoAgentWrapper>;

  const officeLink = <Link routeName={Route.OfficePage} routeParams={{ id: officeId, source: 'listing_page' }}><AgencyPhoto imageURL={agencyImageUrl} /></Link>;

  const contactImage = agentImageUrl && !showOnlyOffice
    ? agentLink
    : (agencyImageUrl
      ? officeLink
      : (poc.type === PocType.Agent ? (
        <AgentPlaceholder data-auto="agent-image-placeholder" width={big ? 64 : 56} height={big ? 64 : 56} />
      ) : (
        <UserPlaceholder data-auto="user-image-placeholder" width={big ? 64 : 56} height={big ? 64 : 56}/>
      )));

  return (
    <PhotoWrapper>
      {contactImage}
    </PhotoWrapper>
  );
};

export default HebrewContactImage;
